// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QzDXD","description":"styles_description__U88IG","button":"styles_button__gDGiu"};